import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class FilterByOrder extends Component {
    setOrder(priority, isChecked) {
        const order = {...this.props.mlbFilters.order};
        order[priority] = isChecked;

        this.props.dispatch(Action.set('HittersOrder', order));
    }

    render() {
        const {mlbFilters} = this.props;

        return (
            <div>
                <strong className="filter-sub-title">Batting order from:</strong>
                <div className="form-inline gap-row-5">
                    {Object.keys(mlbFilters.order).map((priority) => {
                        const isChecked = mlbFilters.order[priority];

                        return (
                            <InputCheckbox
                                key={priority}
                                label={priority}
                                checked={isChecked}
                                onChange={(value) => ::this.setOrder(priority, value)}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {mlbFilters} = state.playersData;

    return {
        mlbFilters,
    };
}

export default connect(mapStatesToProps)(FilterByOrder);
